import { render, staticRenderFns } from "./CreateLanguage.vue?vue&type=template&id=16ab9c2e&scoped=true"
import script from "./CreateLanguage.vue?vue&type=script&lang=js"
export * from "./CreateLanguage.vue?vue&type=script&lang=js"
import style0 from "./CreateLanguage.vue?vue&type=style&index=0&id=16ab9c2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ab9c2e",
  null
  
)

export default component.exports